import React, { useMemo } from 'react';

import CrossIcon from '@atlaskit/icon/glyph/cross';
import MediaServicesTextIcon from '@atlaskit/icon/glyph/media-services/text';
import PeopleGroupIcon from '@atlaskit/icon/glyph/people-group';
import { components } from '@atlaskit/select';

import { JIRA_ICON, PD_ICON } from 'src/lib/featureFlags';

const IconContainer = ({ icon, iconsBaseUrl }) => {
  if (icon === 'pd') icon = PD_ICON;
  if (icon === 'jira') icon = JIRA_ICON;
  if (icon === 'text') icon = <MediaServicesTextIcon/>;
  if (icon === 'cross') icon = <CrossIcon/>;
  if (icon === 'org') icon = <PeopleGroupIcon/>;
  if (icon === 'group') icon = <PeopleGroupIcon/>;

  if (typeof icon === 'string') {
    const [, color] = icon.split('rect_color_');
    if (color) {
      icon = (<svg width="24" height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">

        <rect x="2" y="4" width="14" height="14" rx="3" ry="3" fill={`#${color}`}/>
      </svg>);
    }
  }

  if (typeof icon === 'object') {
    return <span style={{ width: '1rem', maxHeight: '1rem', margin: '-2px 6px 4px 2px' }}>{icon}</span>;
  }

  if (typeof icon === 'string' && icon.startsWith('/') && iconsBaseUrl) {
    icon = iconsBaseUrl + icon;
  }

  return <img src={icon} alt=" " style={{ width: '1rem', maxHeight: '1rem', marginRight: '6px', marginLeft: '2px' }}/>;
};

const multiValueLabelContainerFactory = iconsBaseUrl => ({ children, data: { icon } }) => {
  if (!icon) {
    return (
      <div style={{ marginLeft: '0.4em' }}>
        {children}
      </div>
    );
  }

  let spanStyle = {};
  if (icon === 'text') {
    spanStyle = { width: '90%', whiteSpace: 'pre-wrap' };
  }

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', paddingRight: '4px' }}>
      <IconContainer icon={icon} iconsBaseUrl={iconsBaseUrl}/>
      <span style={spanStyle}>{children}</span>
    </div>
  );
};

const singleValueContainerFactory = iconsBaseUrl => ({ children, data: { icon }, ...rest }) => {
  return (
    <components.SingleValue {...rest}>
      <div style={{ display: 'inline-flex', alignItems: 'center', paddingRight: '4px' }}>
        {icon && <IconContainer icon={icon} iconsBaseUrl={iconsBaseUrl}/>}
        <span>{children}</span>
      </div>
    </components.SingleValue>
  );
};

const optionContainerFactory = iconsBaseUrl => ({ children, data: { icon }, ...props }) => {
  let body = children;
  if (icon) {
    body =
      (<div style={{ display: 'inline-flex', alignItems: 'center', paddingRight: '4px' }}>
        <IconContainer icon={icon} iconsBaseUrl={iconsBaseUrl}/>
        <span>{children}</span>
      </div>);
  }

  return (
    <components.Option {...props}>
      {body}
    </components.Option>
  );
};


export const withIconsSupport = C => ({ hasIcons, iconsBaseUrl, ...props }) => {
  const components = useMemo(() => {
    if (!hasIcons) return undefined;
    return {
      MultiValueLabel: multiValueLabelContainerFactory(iconsBaseUrl),
      Option: optionContainerFactory(iconsBaseUrl),
      SingleValue: singleValueContainerFactory(iconsBaseUrl),
    };
  }, [hasIcons, iconsBaseUrl]);

  return (
    <C
      components={components}
      {...props}
    />
  );
};
